// extracted by mini-css-extract-plugin
export default {"root":"MN99i","space":"FpD83","link":"vxciX","cover":"wnbZF","placeholder":"ZCpiV"};